<template>
    <div class="users-container">
        <!-- Filtros Avançados -->
        <AdvancedFilters 
            ref="advancedFilters"
            :show-date-filter="true"
            :show-course-filter="false"
            :show-user-filter="true"
            @filters-applied="onFiltersApplied"
            @filters-cleared="onFiltersCleared"
        />

        <Loader v-if="!hasReady" />
        <div v-else>
            <v-table class="custom-table table-with-filters">
                <thead>
                    <tr>
                        <th style="width: 50%; text-align: left;" class="sortable-header" @click="sortBy('title')">
                            Título
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 25%; text-align: left;" class="sortable-header" @click="sortBy('date')">
                            Data
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 25%; text-align: center;" class="sortable-header" @click="sortBy('status')">
                            Status
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="warnings in paginatedCourses" :key="warnings.id">
                        <td style="width: 50%; text-align: left;">{{ warnings.title }}</td>
                        <td style="width: 25%; text-align: left;">{{ formatDate(warnings.dateInsert) }}</td>
                        <td style="width: 25%; text-align: center;">
                            <v-chip
                                density="compact"
                                :color="warnings.status == 1 ? 'success' : 'warning'"
                            >
                                {{ warnings.status == 1 ? 'Aberta' : 'Fechada' }}
                            </v-chip>
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </div>

        <div class="pagination users-pagination">
            <v-responsive>
                <v-pagination
                    v-model="currentPage"
                    :length="totalPages"
                    :total-visible="5"
                    :disabled="!hasReady"
                    @update:model-value="onPageChange"
                ></v-pagination>
            </v-responsive>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader/loader.vue';
import AdvancedFilters from '@/components/Admin/Reports/AdvancedFilters.vue';
import api from "@/utils/reports.js";
import { mapState } from "vuex";
import { toast } from 'vue3-toastify';

export default {
    data() {
        return {
            label: this.labels,
            userFiltered: [],
            searchTerm: '',
            status: 'all',
            currentPage: 1,
            itemsPerPage: 5,
            alertOpenCourse: false,
            removedcoursename: '',
            afterWidth: 40,
            usersInfo: [],
            openModalCreateWarning: false,
            openModalEditWarning: false,
            hasReady: false,
            indiceItem: [false, false, false, true],
            isMobileIcon: false,
            totalPages: 0,
            currentSort: { field: '', order: 'asc' },
        };
    },
    props: {
        labels: Array
    },
    computed: {
        ...mapState(['token', 'numberIntensTable']),
        paginatedCourses() {
            if (!Array.isArray(this.userFiltered)) {
                return [];
            }
            const startIndex = (this.currentPage - 1) * this.numberIntensTable;
            const endIndex = startIndex + this.numberIntensTable;
            return this.userFiltered.slice(startIndex, endIndex);
        },
        totalPages() {
            return Math.ceil(this.userFiltered.length / this.numberIntensTable);
        },
    },
    methods: {
        exportToCSV() {
            const columnHeaders = ["ID", "Titulo", "Descrição", "Status", "Usuário", "Data", "Lido"];
            let csvContent = "data:text/csv;charset=utf-8,";
            const headers = columnHeaders.join(","); 
            csvContent += headers + "\n";

            csvContent += this.userFiltered.map(user => {
                return [
                    user.id,                                  // ID
                    user.title,                               // Titulo
                    user.description || "Sem descrição",      // Descrição (com fallback para "Sem descrição" se vazio)
                    user.status !== null ? user.status : "Indefinido", // Status (com fallback para "Indefinido")
                    user.nameUser || "Anônimo",               // Usuário (com fallback para "Anônimo" se nulo)
                    user.dateInsert ? new Date(user.dateInsert).toLocaleDateString() : "Data não disponível", // Data formatada (com fallback)
                    user.isRead !== null ? (user.isRead ? "Sim" : "Não") : "Indefinido" // Lido (com fallback)
                ].join(",");
            }).join("\n");

            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "relatorio_avisos.csv");
            document.body.appendChild(link); 
            link.click();
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() returns month from 0 to 11
            const year = date.getUTCFullYear();
            return `${day}/${month}/${year}`;
        },
        async getDataReport() {
            try {
                const response = await api.getDataNotification(this.token);
                this.usersInfo = response.content;
                this.hasActive = true;
                this.userFiltered = response.content;
                this.hasReady = true;
            } catch (error) {
                toast.error('Erro ao buscar os dados do relatório.');
                console.error('Erro Report Users', error)
            }
        },
        filteredCourses() {
            if (this.searchTerm.trim() === '') {
                this.userFiltered = this.usersInfo;
            } else {
                this.userFiltered = this.usersInfo.filter((user) =>
                    user.name.toLowerCase().includes(this.searchTerm.toLowerCase())
                );
            }
            return this.userFiltered;
        },
        filteredCoursesStatus() {
            if (this.status == 'all') {
                this.userFiltered = this.usersInfo;
            } else {
                this.userFiltered = this.usersInfo.filter((course) =>
                    course.status.toLowerCase() === this.status.toLowerCase()
                );
            }
            return this.userFiltered;
        },
        onPageChange(page) {
            this.currentPage = page;
        },
        removecourse(id, name) {
            this.removedcoursename = name;
            this.alertOpenCourse = !this.alertOpenCourse;
            setTimeout(() => {
                this.alertOpenCourse = !this.alertOpenCourse;
                this.removedcoursename = '';
            }, 4000);
        },
        edit(id) {
            this.openModalEditWarning = !this.openModalEditWarning;
        },
        create() {
            this.openModalCreateWarning = !this.openModalCreateWarning;
        },
        updatevalueCreate(newvalue) {
            this.openModalCreateWarning = newvalue;
        },
        updatevalueEdit(newvalue) {
            this.openModalEditWarning = newvalue;
        },
        filterByDate(period, index) {
            this.indiceItem = this.indiceItem.map((item, i) => i === index ? true : false);
            const now = new Date();
            let startDate;

            switch (period) {
                case 'today':
                    startDate = new Date(now.setHours(0, 0, 0, 0));
                    break;
                case 'last30days':
                    startDate = new Date(now.setDate(now.getDate() - 30));
                    break;
                case 'last90days':
                    startDate = new Date(now.setDate(now.getDate() - 90));
                    break;
                case 'alltime':
                    this.userFiltered = this.usersInfo;
                    return;
            }
            this.userFiltered = this.usersInfo.filter((course) => {
                const courseDate = new Date(course.dateInsert);
                return courseDate >= startDate;
            });
        },
        filterByCustomDate(event) {
            const selectedDate = new Date(event.target.value);
            if (!selectedDate) {
                this.userFiltered = this.usersInfo;
            }
            this.userFiltered = this.usersInfo.filter((course) => {
                const courseDate = new Date(course.dateInsert);
                return courseDate >= selectedDate;
            });
        },
        onFiltersApplied(filters) {
            this.applyAdvancedFilters(filters);
        },
        onFiltersCleared() {
            this.clearAdvancedFilters();
        },
        async applyAdvancedFilters(filters) {
            try {
                this.hasReady = false;
                
                // Aplicar filtros locais nos dados já carregados
                let filteredData = [...this.usersInfo];
                
                // Filtro por data
                if (filters.dateFrom) {
                    filteredData = filteredData.filter(item => {
                        const itemDate = new Date(item.dateInsert);
                        const fromDate = new Date(filters.dateFrom);
                        return itemDate >= fromDate;
                    });
                }
                
                // Filtro por nome do usuário (título do aviso)
                if (filters.userName) {
                    filteredData = filteredData.filter(item =>
                        item.title.toLowerCase().includes(filters.userName.toLowerCase())
                    );
                }
                
                this.userFiltered = filteredData;
                this.currentPage = 1;
                this.hasReady = true;
                
            } catch (error) {
                toast.error('Erro ao aplicar filtros.');
                console.error('Erro ao aplicar filtros:', error);
                this.hasReady = true;
            }
        },
        clearAdvancedFilters() {
            this.userFiltered = [...this.usersInfo];
            this.currentPage = 1;
        },
        sortBy(field) {
            if (this.currentSort.field === field) {
                this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort.field = field;
                this.currentSort.order = 'asc';
            }
            
            this.userFiltered = this.sortData([...this.userFiltered], field, this.currentSort.order);
        },
        sortData(data, sortBy, sortOrder) {
            return data.sort((a, b) => {
                let aValue, bValue;
                
                switch (sortBy) {
                    case 'title':
                        aValue = a.title.toLowerCase();
                        bValue = b.title.toLowerCase();
                        break;
                    case 'date':
                        aValue = new Date(a.dateInsert);
                        bValue = new Date(b.dateInsert);
                        break;
                    case 'status':
                        aValue = parseInt(a.status) || 0;
                        bValue = parseInt(b.status) || 0;
                        break;
                    default:
                        return 0;
                }
                
                if (sortOrder === 'asc') {
                    return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
                } else {
                    return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
                }
            });
        },
    },
    components: {
        Loader,
        AdvancedFilters
    },
    created() {
        this.getDataReport();
        this.userFiltered = this.usersInfo;
    },
};
</script>

<style scoped>

.search-form-input {
    position: relative;
    width: 100%;
}
.title-container {
    position: relative;
    margin-bottom: 10px;
    padding-bottom: 0;
    border-bottom: 1px solid #f0f0f0;
    text-align: left;
}

.title-container .title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #000000;
    margin-bottom: 0.5rem;
}

.title-container .subtitle {
    color: #6b7280;
    font-size: 0.875rem;
    line-height: 1.4;
    margin-bottom: 1rem;
}

.export-button-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.export-button-container .btn-weflix {
    background-color: #2f2e8b;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
    border: none;
}

.export-button-container .btn-weflix:hover:not(:disabled) {
    background-color: #23225f;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(47, 46, 139, 0.3);
}

.export-button-container .btn-weflix:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
}

.export-button-container .btn-weflix svg {
    font-size: 1rem;
}

.search-row {
    display: flex;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
}

.search-row .form-group {
    flex: 1;
}

.btn-weflix.absolute {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #2f2e8b;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
}

.btn-weflix.absolute:hover {
    background-color: #23225f;
    transform: translateY(-2px);
}

.users-table-responsive {
    background-color: #ffffff;
    border-radius: 8px;
    margin-bottom: 1rem;
}

.users-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.users-table th {
    background-color: #f8fafc;
    padding: 0.75rem;
    font-weight: 600;
    color: #4a5568;
    text-align: left;
    border-bottom: 2px solid #e2e8f0;
}

.users-table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-bottom: 1px solid #f0f0f0;
    color: #4a5568;
}

.users-table tr:hover {
    background-color: #f8fafc;
}

.badge-active, .badge-inactive {
    padding: 0.25rem 0.75rem;
    border-radius: 5px;
    font-size: 0.75rem;
    font-weight: 500;
    display: inline-block;
    text-align: center;
    transition: all 0.2s ease;
    width: fit-content;
}

.badge-active {
    background-color: #7bcc8180;
    color: #4b614e;
}

.badge-inactive {
    background-color: #d7d7ee80;
    color: #2f2e8b;
}

.dark .badge-active,
    .dark .badge-inactive {
        color: #fff;
    }

.user-btn-edit {
    padding: 0.4rem;
    margin: 0 0.25rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: #2f2e8b;
}

.search-form-input {
    position: relative;
}

.search-form-control {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.875rem;
    transition: all 0.2s ease;
}

.search-form-control:focus {
    outline: none;
    border-color: #2f2e8b;
    box-shadow: 0 0 0 3px rgba(47, 46, 139, 0.1);
}

.search-input-icon {
    position: absolute;
    right: 0.75rem;
    top: 45%;
    transform: translateY(-50%);
    color: #9ca3af;
    cursor: pointer;
}

.users-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 1rem;
    padding-bottom: 10px;
}

.users-page-btn {
    padding: 0.5rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: white;
    color: #4a5568;
    cursor: pointer;
    transition: all 0.2s;
}

.users-page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.users-page-btn:not(:disabled):hover {
    background: #f8fafc;
    border-color: #cbd5e0;
}

.users-page-info {
    color: #4a5568;
    font-size: 0.875rem;
}

@media (max-width: 768px) {

    .title-container {
        margin-bottom: 1.5rem;
    }

    .search-row {
        flex-direction: column;
    }

    .users-table th, .users-table td {
        padding: 0.5rem;
    }
}

@media (max-width: 600px) {
    .btn-weflix.absolute {
        padding: 0.5rem;
    }
    
    .btn-weflix.absolute span {
        display: none;
    }

    .users-table-responsive {
        overflow-x: auto;
    }
}

select.form-control.filter-form-control {
    width: 60%;
}
.form-group.filter-form-group {
    justify-content: space-around;
    align-items: center;
    margin: 0 !important;
}
.form-group.search-form-group {
    margin: 0 !important;
}
table.table.users-table {
    border: none !important;
    padding: 0 !important;
}
button.btn-edit.user-btn-edit svg {
    color: #2f2e8b;
}
.form-group.filter-form-group {
    display: flex;
}
.btn-weflix.absolute span.flex {
    font-size: 16px;
}
.btn-weflix.absolute svg {
    color: white;
    font-size: 15px;
}
/* DARK */
.dashboard.dark .users-table-responsive {
    background-color: #000 !important;
}
.dashboard.dark .weeducAdminReports .page-info.users-page-info {
    color: white;
}
.dashboard.dark .weeducAdminReports .users-table th {
    border-bottom: 2px solid #575757 !important;
}
.dashboard.dark .weeducAdminReports .users-table td {
    border-bottom: 2px solid #575757 !important;
}

.sortable-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
    position: relative;
}

.sortable-header:hover {
    background-color: #f1f3f4;
}

.sort-icon {
    margin-left: 0.5rem;
    opacity: 0.5;
    transition: opacity 0.2s ease;
}

.sortable-header:hover .sort-icon {
    opacity: 1;
}

.dashboard.dark .sortable-header:hover {
    background-color: #666;
}

.table-with-filters {
    border-radius: 0 0 6px 6px;
    border: 1px solid #e2e8f0;
    border-top: none;
    overflow: hidden;
}

.dashboard.dark .table-with-filters {
    border-color: #444;
}
</style>
